import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type updateAnnotationType = {
  move_id: string | number;
  annotation?: string;
  annotation_icon?: string;
  hint?: string;
  success_message?: string;
  deviation_message?: string;
};
export default function useStudyUpdateAnnotation() {
  return useMutation(async (payload: updateAnnotationType) => {
    const response = await ChessRestClient.post(
      `learning/study_games_moves/update_annotation/`,
      payload,
    );
    return response.data;
  });
}
